import React, { Component } from 'react';
import './Content_Area.css';
import './Text_Styles.css';
import Switch_Content from './Switch_Content';

export default class Content_Area extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active_content: 'Login_Page',
			param: {},
		}
		this.switch_content = React.createRef();

	}

	content_handler(arg, param) {
		// console.log('arg = ' + arg + ' param = '+ JSON.stringify(param))

		// active_content is the page to switch to
		// param is the parameters to pass from page to page
		this.setState({
			param: param,
			active_content: arg,
		});
	}

	render() {
		let content_handler = this.content_handler;

		return (
			<Switch_Content
				receiver={this.props.receiver}
				ref={this.switch_content}
				tag={this.state.active_content}
				param={this.state.param}
				content_handler={content_handler.bind(this)}
				width={this.props.width}
				height={this.props.height}
				colours={this.props.colours}
				is_mobile={this.props.receiver.is_mobile}
			/>
		)
	}
}